"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSimplifiedCacheKey = void 0;
var _constants = require("../constants");
var _isEmptyObject = require("./isEmptyObject");
const createSimplifiedCacheKey = options => {
  if (!options) {
    return null;
  }
  const {
    url,
    query,
    headers,
    variables
  } = options;
  const headersForCacheKey = {
    ...headers
  };
  if (Object.hasOwn(headersForCacheKey, _constants.AUTHORIZATION)) {
    delete headersForCacheKey[_constants.AUTHORIZATION]; // We do not wan't to store token in cache as it differs on server and client.
  }
  // Return a cache key object with non-empty properties
  const cacheKey = {
    ...(url && {
      url
    }),
    ...(query && {
      query
    }),
    ...(variables != null && !(0, _isEmptyObject.isEmptyObject)(variables) && {
      variables
    }),
    ...(headers && !(0, _isEmptyObject.isEmptyObject)(headersForCacheKey) && {
      headers: headersForCacheKey
    })
  };
  return cacheKey;
};
exports.createSimplifiedCacheKey = createSimplifiedCacheKey;
